<div class="content-container" role="main" aria-live="assertive">
  <div class="card-shadow-wrapper">
    @if (theme.theme.mainTheme !== themeType.Custom) {
      <id-card>
        <ng-container *ngTemplateOutlet="mtlsRotationLimitContent"></ng-container>
      </id-card>
    } @else {
      <div class="custom-card">
        <ng-container *ngTemplateOutlet="mtlsRotationLimitContent"></ng-container>
      </div>
    }
  </div>

  <ng-template #mtlsRotationLimitContent>
    <div class="flex flex-column flex-align-center">
      <img class="icon" src="assets/images/mtls-icon.svg" alt="SITHS eID ikon" />
      <h1 class="{{ theme.theme.mainTheme !== themeType.Custom ? 'ids-heading-xl' : 'custom-heading-xl' }} ids-mt-5">
        För många {{ getMethodTypeInstructionsText() }} via dubbelriktad TLS
      </h1>
    </div>

    <div class="instructions-text-container ids-mt-5">
      <p class="instructions-text">
        Du har genomfört för många {{ getMethodTypeInstructionsText() }} via dubbelriktad TLS i din pågående session
        utan att starta om din webbläsare. Starta om webbläsaren och återgå till din e-tjänst för att börja
        {{ getMethodTypeText() }}!
      </p>
      <p class="instructions-text">
        Om du nyligen startat om webbläsaren kan du även få denna varning på grund av inställningarna i din webbläsare
        som gör att webbläsaren ska starta upp i samma läge som när den stängdes ned senast.
      </p>
    </div>

    <div class="ids-mt-5 flex flex-column align-center">
      <id-link>
        <a href="javascript:void(0);" (click)="cancel()">Avbryt {{ getMethodTypeText() }}</a>
      </id-link>
    </div>
  </ng-template>
</div>
